const errorMappings = {
  name: {
    'already exists': 'Nama Penjadwalan sudah terdaftar di sistem.',
  },
}

export default errorMappings